<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span class="main-r_top_nav" :class="mainStatus === 'online' && 'active'" @click.stop="handleClick('online')">{{ $t("apiDoc.在线文档") }}</span>
      <span class="main-r_top_nav" :class="mainStatus === 'apiTest' && 'active'" @click.stop="handleClick('apiTest')">{{ $t("apiDoc.测试工具") }}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'

const apiUrlTest = 'logistics/trace';
export default {
  components: { onlineDoc , apiTestDoc },
  data() {
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.trackDescription_1')}`,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[

        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`,},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`,},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳，毫秒')}`,},
                    ]
            },
             {
                title:`${this.$t('onlineDoc.请求参数')}`,
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
                ]
            },
            {
              title:`${this.$t('onlineDoc.业务参数')}`,
              value:[
                {name: "billCodes",type: "String(500)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.运单号，多个运单号以英文逗号隔开,目前先支持一次性最多查询30票运单')}`}
              ]
            }

        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[

        //   响应参数
            {
                title:`${this.$t('onlineDoc.响应参数')}`,
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码，见附录')}`,},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`,},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务数据')}`,},
                  ]
            },
            {
              title:`${this.$t('onlineDoc.data类型说明')}`,
              value:[
                  {name: "billCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.运单号')}`},
                  {name: "details",type: "Array",require: "Y",normal: "",describe: `${this.$t('onlineDoc.运单轨迹详情')}`}
                ]
            },
            {
              title:`${this.$t('onlineDoc.details类型说明')}`,
              value:[
                  {name: "scanTime",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.扫描时间')}`},
                  {name: "desc",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.轨迹描述')}`},
                  {name: "scanType",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.scanType')}`},
                  {name: "scanTypeCode",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.scanTypeCode')}`},
                  {name: "scanNetworkName",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.扫描网点名称')}`},
                  {name: "scanNetworkId",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.扫描网点ID')}`},
                  {name: "staffName",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务员姓名')}`},
                  {name: "staffContact",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务员联系方式')}`},
                  {name: "scanNetworkContact",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.扫描网点联系方式')}`},
                  {name: "scanNetworkProvince",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.扫描网点省份')}`},
                  {name: "scanNetworkCity",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.扫描网点城市')}`},
                  {name: "scanNetworkArea",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.扫描网点区/县')}`},
                  {name: "nextStopName",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.上一站(到件)或下一站名称(发件)')}`},
                  {name: "nextNetworkProvinceName",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.下一站省份（发件扫描类型时提供）')}`},
                  {name: "nextNetworkCityName",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.下一站城市（发件扫描类型时提供）')}`},
                  {name: "nextNetworkAreaName",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.下一站区/县（发件扫描类型时提供）')}`},
                  {name: "sigPicUrl",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.签收图片（签收扫描时，展示该数据）')}`},
                  {name: "electronicSignaturePicUrl",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.电子签名（签收扫描时，展示该数据）')}`},
                  {name: "longitude",type: "BigDecimal",require: "N",normal: "",describe: `${this.$t('onlineDoc.经度（在问题件扫描时回传）')}`},
                  {name: "latitude",type: "BigDecimal",require: "N",normal: "",describe: `${this.$t('onlineDoc.纬度（在问题件扫描时回传）')}`},
                  {name: "otp",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.OTP验证码（签收扫描类型时提供）')}`},
                  {name: "problemPicUrl",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.问题件图片（在问题件扫描时提供）')}`},
                  {name: "secondLevelTypeCode",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.问题件二级编码')}`},
                  {name: "arrivalPicUrl",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.到件图片（到件扫描时，展示该数据，多张图片以逗号分割）')}`},
                  {name: "chargedWeight",type: "Number",require: "N",normal: "",describe: `${this.$t('onlineDoc.计费重量')}`},
                  {name: "packageLength",type: "Number",require: "N",normal: "",describe: `${this.$t('onlineDoc.包裹总长')}`},
                  {name: "packageWide",type: "Number",require: "N",normal: "",describe: `${this.$t('onlineDoc.包裹总宽')}`},
                  {name: "packageHigh",type: "Number",require: "N",normal: "",describe: `${this.$t('onlineDoc.包裹总高')}`},
                ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=292508153084379141
    digest=6D0yAYAtRwIaLCJOdIPrXw==
    timestamp=1638429647724

Body：
    bizContent= "{'billCodes': 'UTE010001093135'}"`,
        //返回示例
        responseCode: JSON.parse(`{"code":"1","msg":"success","data":[{"billCode":"UTE010001093135","details":[{"billCode":"UTE010001093135","scanTime":"2021-11-17 12:15:43","desc":"The parcel has been signed by [YAUA], if you have any questions, please contact: +966-135141216456, If you have any problems or need to complain, please call the station： ","scanType":"Sign scan","scanNetworkTypeName":"网点","scanNetworkName":"Riyadh station 1","scanNetworkId":193,"scanNetworkProvince":"Riyadh","scanNetworkCity":"Riyadh","sigPicUrl":"https://image.baidu.com/search/detail?ct=503316480","electronicSignaturePicUrl":"https://image.baidu.com/search/detail?ct=503316480"},{"billCode":"UTE010001093135","scanTime":"2021-11-17 12:06:57","desc":"[Riyadh station 1] J&T courier 英武(+966-135141216456) has picked up the parcel. If you have any problems or need to complain, please call the station :","scanType":"Pickup scan","scanNetworkTypeName":"网点","scanNetworkName":"Riyadh station 1","scanNetworkId":193,"scanNetworkProvince":"Riyadh","scanNetworkCity":"Riyadh"},{"billCode":"UTE010001093135","scanTime":"2021-11-17 11:49:15","desc":"[测试网点-1]'s courier lisisi02(+966-15220167300) is delivering, if you have any  problems or need to complain, please call the station:","scanType":"Delivery scan","scanNetworkTypeName":"网点","scanNetworkName":"测试网点-1","scanNetworkId":156,"scanNetworkProvince":"Al Baha","scanNetworkCity":"Al Baha"},{"billCode":"UTE010001093135","scanTime":"2021-11-17 11:49:02","desc":"The parcel has arrived at [测试网点-1]","scanType":"Station arrival","scanNetworkTypeName":"网点","scanNetworkName":"测试网点-1","scanNetworkId":156,"scanNetworkProvince":"Al Baha","scanNetworkCity":"Al Baha"},{"billCode":"UTE010001093135","scanTime":"2021-11-17 11:48:56","desc":"The parcel left [测试网点-1] and was sent to [Jebei ali]","scanType":"Sending scan","scanNetworkTypeName":"网点","scanNetworkName":"测试网点-1","scanNetworkId":156,"scanNetworkProvince":"Al Baha","scanNetworkCity":"Al Baha","nextStopName":"Jebei ali"},{"billCode":"UTE010001093135","scanTime":"2021-11-17 11:46:55","desc":"[测试网点-1] J&T courier 英武(13544244886) has picked up the parcel. If you have any problems or need to complain, please call the station :","scanType":"Pickup scan","scanNetworkTypeName":"网点","scanNetworkName":"测试网点-1","scanNetworkId":156,"scanNetworkProvince":"Al Baha","scanNetworkCity":"Al Baha"},{"billCode":"UTE010001093135","scanTime":"2021-11-17 11:42:59","desc":"[测试网点-1] J&T courier 英武(13544244886) has picked up the parcel. If you have any problems or need to complain, please call the station :","scanType":"Pickup scan","scanNetworkTypeName":"网点","scanNetworkName":"测试网点-1","scanNetworkId":156,"scanNetworkProvince":"Al Baha","scanNetworkCity":"Al Baha"}]}]}`),

        //错误代码提示
        errcodeJson: [{code:'145003100',msg:`${this.$t('apiTestDoc.运单号非法')}`},
          {code:'145003502',msg:`${this.$t('apiTestDoc.运单号个数超过30')}`}]
      },

      apiTestData: {
          _headerData: {
            apiAccount: "292508153084379141",
            digest: "6D0yAYAtRwIaLCJOdIPrXw==",
            timestamp: "1638429647724",
          },
          data:{
             bizContent: `{'billCodes': 'UTE010001093135'}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: [{code:'145003100',msg:`${this.$t('apiTestDoc.运单号非法')}`},
          {code:'145003502',msg:`${this.$t('apiTestDoc.运单号个数超过30')}`}]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>
